import Vue from 'vue'
import laravel from '@/helpers/laravel'
import moment from 'moment'

export default {
  setShowPreloader(state, showPreloader) {
    state.showPreloader = showPreloader
  },
  setTitle(state, title) {
    state.title = title
  },
  setMenu(state, menu) {
    state.menu = menu
  },
  setOpenedSettings(state, openedSettings) {
    state.openedSettings = openedSettings
  },
  setUser(state, user) {
    state.user = user
  },
  setUserAvatar(state, value) {
    const STORAGE_PATH = Vue.config.modules.crm.storage
    state.userAvatar = `${STORAGE_PATH}${value}`
  },
  setUserField(state, obj) {
    if (state.user) {
      state.user[obj.key] = obj.value
    }
  },
  setUserStatus(state, status) {
    state.userStatus = status
  },
  setOverlay(state, overlay) {
    state.overlay = overlay
  },
  setLoad(state, load) {
    state.load = load
  },
  setSelectedDate(state) {
    state.selectedDate =
      state.route.query && state.route.query.selected_date ? moment(state.route.query.selected_date) : moment()
  },
  setEmployerPermissions(state, permissions) {
    const mergedPermissions = {
      ...(_.isObject(permissions.units) ? permissions.units : {}),
      ...(_.isObject(permissions.company) ? permissions.company : {}),
    }

    const finallyPermissions = {}

    _.map(mergedPermissions, (value, index) => {
      if (!finallyPermissions.hasOwnProperty(index)) {
        finallyPermissions[index] = {}
      }

      _.each(value, (subValue, subIndex) => {
        finallyPermissions[index][subIndex] = true
      })
    })

    state.selfPermissions = Object.keys(laravel.array_dot(finallyPermissions))
  },
  setTimezone(state, timezone) {
    state.timezone = timezone
  },
}
